<template>
    <div class="head-box">
      <div class="head-title flex-conter">
        <div class="game-name overflow-text">{{ match.chineseName }}</div>
        <!-- <div>上海市民足球公园</div> -->
      </div>
      <div class="head-content flex-conter" v-if="obj.homeTeam">
        <div class="left flex-conter" style="flex-direction: column;">
          <img :src="obj.homeTeam.badge" />
          <div class="overflow-text">{{ obj.homeTeam.name }}</div>
        </div>
        <div class="content">
          <div class="flex-conter" style="flex-direction: column;" v-if="false">
            <div class="state">未开赛</div>
            <div>7-23 周三 20:00</div>
          </div>
          <div class="score-box">
            <div class="score flex-conter">
              <div class="flex-conter" style="justify-content: space-evenly;">
                <img :src="`http://images.snsports.cn/bsn_number${homeTeam.scoreA}.png`" />
                <img :src="`http://images.snsports.cn/bsn_number${homeTeam.scoreB}.png`" v-if="homeTeam.scoreB !== -1" />
              </div>
              <img src="http://images.snsports.cn/bsn_vs_bf.png" />
              <div class="flex-conter" style="justify-content: space-evenly;">
                <!-- <img src="http://images.snsports.cn/bsn_vs_-.png" /> -->
                <img :src="`http://images.snsports.cn/bsn_number${awayTeam.scoreA}.png`" />
                <img :src="`http://images.snsports.cn/bsn_number${awayTeam.scoreB}.png`" v-if="awayTeam.scoreB !== -1" />
              </div>
            </div>
            <div class="name">比赛中</div>
          </div>
        </div>
        <div class="right flex-conter" style="flex-direction: column;">
          <img :src="obj.awayTeam.badge" />
          <div class="overflow-text">{{ obj.awayTeam.name }}</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    obj: {
      type: Object,
      default: () => {}
    },
    match: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      awayTeam: {
        scoreA: '',
        scoreB: ''
      },
      homeTeam: {
        scoreA: '',
        scoreB: ''
      }
    }
  },
  watch: {
    obj: {
      handler(newValue) {
        console.log(newValue, '----')
        if (!newValue) return
        const a = newValue.homeTeam.score
        const b = newValue.awayTeam.score
        if (a < 10) {
          this.homeTeam.scoreA = 0
          this.homeTeam.scoreB = newValue.homeTeam.score
        } else {
          this.homeTeam.scoreA = Number(parseInt(a / 10))
          this.homeTeam.scoreB = a % 10
        }
        if (b < 10) {
          this.awayTeam.scoreA = 0
          this.awayTeam.scoreB = newValue.awayTeam.score
        } else {
          this.awayTeam.scoreA = Number(parseInt(b / 10))
          this.awayTeam.scoreB = b % 10
        }
      }
      // immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.head-box{
  .head-title{
    // width: 343px;
    height: 32px;
    background-color: #383838;
    border-radius: 4px 4px 0px 0px;
    background-image: url('http://images.snsports.cn/bsn_title_bc.png');
    background-size: 343px 32px;
    padding: 0 10px;
    font-weight: 500;
    color: #FFFFFF;
    font-size: 12px;
  }
  .head-content{
    margin-top: 2px;
    // width: 343px;
    height: 104px;
    background: #383838;
    border-radius: 0px 0px 4px 4px;
    color: rgba(255,255,255,0.7);
    font-size: 12px;
    padding: 0 21px;
    .left,.right{
      width: 60px;
      img{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-bottom: 7px;
      }
    }
    .content{
      text-align: center;
      line-height: 31.5px;
      color: rgba(255,255,255,0.7);
      font-size: 11.5px;
      max-height: 60px;
      .state{
        height: 104px;
        width: 112.5px;
        height: 31.5px;
        border-radius: 4px;
        background: #555555;
        margin-bottom: 4px;
      }
      .score-box{
        .name{
          margin-top: 5px;
          color: rgba(255, 255, 255, 0.7);
          font-size: 11.5px;
        }
      }
      .score{
        div{
          width: 43px;
          height: 31.5px;
          background: #555555;
          border-radius: 4px;
          img{
            margin: 0;
          }
        }
        img{
          width: 15px;
          height: 23.5px;
          margin: 0 5px;
        }
      }
    }
  }
}
.flex-conter{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.overflow-text{
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
